module.exports = __webpack_public_path__ + "xls.png?022bf15497ba70de2cd4ce9d028f825c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attachment-format/xls.png
// module id = 51
// module chunks = 0